import React from 'react';

const Mensaje = () => (
     <p>Agrega una cantidad y plazo a pagar para comenzar</p>
);
 
export default Mensaje;